function ThirdDesc() {
  return null;
}

export default ThirdDesc;
